import LoginPage from "./LoginPage";

export default LoginPage;

export * from "./LoginPage";
